<template>
  <div class="d-flex justify-content-center">
    <span class="text-white mr-2 text-md">{{ label }} :</span>
    <span class="text-success text-md text-monospace">{{
      points.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PointAmount',
  props: ['keyMap', 'label'],
  computed: {
    ...mapState({
      points(state) {
        return parseFloat(state.user[this.keyMap]);
      },
    }),
  },
};
</script>
